// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.19.3';
//# sourceMappingURL=version.js.map